import _Nag from './Nag';

import './style/index.js';

export * from './type';

export const Nag = _Nag;

export default Nag;
